import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import PageHeader from "./ui/PageHeader";
import DataCard from "./ui/DataCard";
import LoadingState from "./ui/LoadingState";
import AlertBanner from "./ui/AlertBanner";

const API = process.env.REACT_APP_API_BASE || "http://localhost/webservices/dashboard";

const BillingCommission = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch(`${API}/billing/summary.php`)
      .then((r) => r.json())
      .then((p) => { if (!p.status) throw new Error(p.message); setData(p.data); })
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <LoadingState message="Loading billing data..." />;
  if (error) return <AlertBanner type="danger" message={error} />;

  return (
    <div>
      <PageHeader title="Billing & Commission" subtitle="Service charges, fees and agent commissions (INR)" />

      <DataCard title="Service Charges & Fees">
        <Table responsive className="billr-table mb-0">
          <thead><tr><th>Service</th><th>Charge (₹)</th><th>Fee (₹)</th><th>Commission (₹)</th></tr></thead>
          <tbody>
            {data.commission.map((item, i) => (
              <tr key={i}><td><strong>{item.service}</strong></td><td>{item.charge}</td><td>{item.fee}</td><td>{item.commission}</td></tr>
            ))}
          </tbody>
        </Table>
      </DataCard>

      <DataCard title="Refunds & Adjustments">
        <Table responsive className="billr-table mb-0">
          <thead><tr><th>Date</th><th>Type</th><th>Amount (₹)</th></tr></thead>
          <tbody>
            {data.refunds.map((item, i) => (
              <tr key={i}><td>{item.date}</td><td>{item.type}</td><td>{item.amount}</td></tr>
            ))}
          </tbody>
        </Table>
      </DataCard>

      <DataCard title="Agent Commissions">
        <Table responsive className="billr-table mb-0">
          <thead><tr><th>Agent</th><th>Service</th><th>Commission (₹)</th></tr></thead>
          <tbody>
            {data.agents.map((item, i) => (
              <tr key={i}><td>{item.agent}</td><td>{item.service}</td><td>{item.commission}</td></tr>
            ))}
          </tbody>
        </Table>
      </DataCard>
    </div>
  );
};

export default BillingCommission;
